module.exports = __webpack_public_path__ + "static/media/imagenMarfil.f795fe96.png";